import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/atoms/badge';
import { cn } from '@/lib/utils';
import type { ProductGroupItem } from '@/lib/types';

interface SizeChipsProps {
  items: ProductGroupItem[];
  currentProductId: string;
  onProductClick?: (refId: string) => void;
}

export function SizeChips({ items, currentProductId, onProductClick }: SizeChipsProps) {
  const navigate = useNavigate();

  const handleClick = (refId: string) => {
    if (refId !== currentProductId) {
      if (onProductClick) {
        onProductClick(refId);
      } else {
        navigate(`/products/${refId}`);
      }
    }
  };

  return (
    <div className="flex gap-2 flex-wrap">
      {items.map((item) => {
        const isCurrent = item.product.refId === currentProductId;

        return (
          <Badge
            key={item.id}
            variant={isCurrent ? 'default' : 'outline'}
            className={cn(
              'cursor-pointer transition-all px-3 py-1',
              isCurrent
                ? 'bg-primary text-primary-foreground'
                : 'hover:border-primary hover:bg-primary/5',
              !isCurrent && 'cursor-pointer',
              isCurrent && 'cursor-default'
            )}
            onClick={() => handleClick(item.product.refId)}
          >
            {item.sizeName || '-'}
          </Badge>
        );
      })}
    </div>
  );
}
